import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { Subscription, debounceTime, filter, retry } from 'rxjs'

import { SharedService } from 'src/app/shared/services/shared.service'
import { gender } from '../../models/products.enum'
import { ProductsService } from '../../services/products.service'
import { categoryListModel } from '../../models/products.model'
import { Router } from '@angular/router'

@Component({
	selector: 'app-products-filter',
	templateUrl: './products-filter.component.html',
	styleUrls: ['./products-filter.component.scss'],
})
export class ProductsFilterComponent implements OnInit, OnDestroy {
	@Output() emitFilter = new EventEmitter()
	@Output() emitFilterCount = new EventEmitter()
	@Input() filterData: any = {
		categoryId: 0,
		subCategoryId: 0,
		subSubCategoryId: 0,
		brandId: 0,
		inStockOnly: null,
		gender: null,
		priceTo: null,
		priceFrom: null,
		dateFrom: '',
		dateTo: '',
	}
	categoryValue: any
	subCategory: any
	subSubcategory: any
	brandValue: any
	categoryFilter: any = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		searchText: '',
	}
	subscription = new Subscription()
	filterForm: FormGroup = new FormGroup({})
	filterCount = 0

	categoryKeyWord = new FormControl('')
	keyWordSubCategory = new FormControl('')
	keyWordSubSubCategory = new FormControl('')
	keywordBrand = new FormControl('')

	showListCategory = false
	showSubCategory = false
	showSubSubCategory: boolean = false
	showListBrand = false

	categoryList!: categoryListModel[]
	subSubCategoryList: any = []
	Brands: any = []
	subCategoryList: any = []
	genders = this.sharedServ.returnEnumArray(gender)

	constructor(
		public translate: TranslateService,
		private sharedServ: SharedService,
		private ProductsService: ProductsService,
		private router: Router,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.initForm()
		Promise.all([this.getBrands(), this.getCategoryList()]).then(() => {
			this.loadFilterState()
		})

		this.keywordBrand.valueChanges
			.pipe(
				filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
				debounceTime(700),
				retry(-1)
			)
			.subscribe((res: any) => {
				this.getBrands(String(this.keywordBrand.value))
			})

		this.subscription.add(
			this.categoryKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.categoryFilter.searchText = this.categoryKeyWord.value
					this.getCategoryList(null, String(this.categoryKeyWord.value))
				})
		)

		this.subscription.add(
			this.keyWordSubCategory.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.ProductsService.getCategoryList(
						String(this.keyWordSubCategory.value),
						this.getController('categoryId').value
					).subscribe((res: any) => {
						this.subCategoryList = res.result
						res.result
							? (this.showSubCategory = true)
							: (this.showSubCategory = false)
						this.showSubSubCategory = false
					})
				})
		)

		this.subscription.add(
			this.keyWordSubSubCategory.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.ProductsService.getCategoryList(
						String(this.keyWordSubSubCategory.value),
						this.getController('subCategoryId').value
					).subscribe((res: any) => {
						this.subSubCategoryList = res.result
						res.result
							? (this.showSubSubCategory = true)
							: (this.showSubSubCategory = false)
					})
				})
		)
		this.countSubscription()
		this.loadFilterState()
	}
	ngOnChanges(): void {
		this.countSubscription()
		this.loadFilterState()
	}
	countSubscription() {
		this.subscription.add(
			this.filterForm.valueChanges.subscribe((val) => {
				this.filterCount = 0
				for (let value in val) {
					if (
						(this.getController(value).value ||
							this.getController(value).value == 0) &&
						value != 'gender'
					) {
						this.filterCount += 1
					} else if (
						value == 'gender' &&
						this.getController(value).value?.length
					) {
						this.filterCount += 1
					}
				}
				this.saveFilterState() // Save state whenever filterCount changes
			})
		)

		this.emitFilterCount.emit(this.filterCount)
	}
	loadFilterState() {
		this.countSubscription()
		const savedFilterData = localStorage.getItem('productFilter')

		if (savedFilterData) {
			const filterState = JSON.parse(savedFilterData)
			this.filterData = { ...filterState }
			this.filterForm.patchValue({
				categoryId: this.filterData.categoryId,
				subCategoryId: this.filterData.subCategoryId,
				subSubCategoryId: this.filterData.subSubCategoryId,
				brandId: this.filterData.brandId,
				inStockOnly: this.filterData.inStockOnly,
				gender: this.filterData.gender,
				priceTo: this.filterData.priceTo,
				priceFrom: this.filterData.priceFrom,
				dateFrom: this.filterData.dateFrom,
				dateTo: this.filterData.dateTo,
			})

			this.filterCount = filterState?.filterCount

			this.emitFilterCount.emit(this.filterCount)

			if (this.Brands) {
				let savedBrand = this.Brands.find(
					(brand: any) => brand.id == this.filterData.brandId
				)
				this.brandValue = savedBrand
			}

			if (this.categoryList) {
				let savedCategory = this.categoryList.find(
					(category: any) => category.id == this.filterData.categoryId
				)
				this.categoryValue = savedCategory
			}

			this.getCategoryList(this.getController('categoryId').value, '', 1).then(
				() => {
					if (this.subCategoryList) {
						const savedSubCategory = this.subCategoryList.find(
							(category: any) => category.id == this.filterData.subCategoryId
						)
						this.subCategory = savedSubCategory
					}
				}
			)

			this.getCategoryList(
				this.getController('subCategoryId').value,
				'',
				2
			).then(() => {
				if (this.subSubCategoryList) {
					const savedSubSubCategory = this.subSubCategoryList.find(
						(category: any) => category.id == this.filterData.subSubCategoryId
					)
					this.subSubcategory = savedSubSubCategory
				}
			})
		}
	}

	initForm() {
		this.filterForm = new FormGroup({
			categoryId: new FormControl(this.filterData.categoryId),
			subCategoryId: new FormControl(this.filterData.subCategoryId),
			subSubCategoryId: new FormControl(this.filterData.subSubCategoryId),
			brandId: new FormControl(this.filterData.brandId),
			inStockOnly: new FormControl(this.filterData.inStockOnly),
			gender: new FormControl(this.filterData.gender),
			priceTo: new FormControl(this.filterData.priceTo),
			priceFrom: new FormControl(this.filterData.priceFrom),
			dateFrom: new FormControl(this.filterData.dateFrom),
			dateTo: new FormControl(this.filterData.dateTo),
		})
	}

	getCategoryList(
		categoryId?: number | null,
		keyword?: string,
		level?: number
	): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			if (keyword) {
				this.categoryFilter.searchText = keyword
			}

			const subscription = this.ProductsService.getCategoryList(
				this.categoryFilter.searchText,
				categoryId
			).subscribe({
				next: (res: any) => {
					if (res) {
						if (!categoryId) {
							this.categoryList = res.result
							this.showSubCategory = !!res.result
							this.showSubSubCategory = false
						} else if (categoryId && level === 1) {
							this.showSubSubCategory = !!res.result
							this.subCategoryList = res.result
						} else if (categoryId && level === 2) {
							this.subSubCategoryList = res.result
						}
					}
					resolve()
				},
			})
		})
	}

	getBrands(searchWord: string = ''): Promise<void> {
		return new Promise((resolve) => {
			this.subscription.add(
				this.ProductsService.getBrandList(searchWord).subscribe({
					next: (res: any) => {
						if (res) {
							this.Brands = res.result
						}
						resolve() // Resolve the promise when brands are fetched
					},
				})
			)
		})
	}

	statusChanged(event: any, controller: string) {
		if (event?.checked) {
			!this.getController(controller).value
				? this.getController(controller).setValue([])
				: null
			this.getController(controller).setValue([
				...this.getController(controller).value,
				event.source.value,
			])
		} else {
			let objIndex = [...this.getController(controller).value]?.indexOf(
				event.source.value
			)
			let newArray = this.getController(controller).value
			newArray.splice(objIndex, 1)
			this.getController(controller).setValue(newArray)
		}
	}

	compareWith(a: any, b: any) {
		return a?.id == b?.id
	}

	allowOnlyNumbers(event: KeyboardEvent) {
		const allowedKeys = [
			'Backspace',
			'Tab',
			'End',
			'Home',
			'ArrowLeft',
			'ArrowRight',
			'ArrowUp',
			'ArrowDown',
		]
		const isNumber = /^[0-9]$/

		if (allowedKeys.includes(event.key) || isNumber.test(event.key)) {
			return // Allow navigation and numeric keys
		} else {
			event.preventDefault() // Prevent non-numeric keys
		}
	}

	getController(controlName: string) {
		return (this.filterForm as FormGroup).controls[controlName]
	}

	submit() {
		console.log(this.filterData, 'filterData')
		console.log(this.filterForm.getRawValue(), 'filterData')

		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.updateUrlParams()
		delete this.filterData.searchText
		this.emitFilter.emit(this.filterData)
		this.emitFilterCount.emit(this.filterCount)
	}

	resetFilter() {
		this.filterForm.reset()

		this.categoryKeyWord.setValue('')
		this.keyWordSubCategory.setValue(null)
		this.keyWordSubSubCategory.setValue(null)
		this.keywordBrand.setValue('')

		this.showListCategory = false
		this.showSubCategory = false
		this.showSubSubCategory = false
		this.showListBrand = false

		this.categoryList = []
		this.subSubCategoryList = []
		this.Brands = []
		this.subCategoryList = []
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.filterCount = 0
		this.emitFilter.emit(this.filterData)
		this.emitFilterCount.emit(this.filterCount)
		this.updateUrlParams()

		this.getCategoryList()
		this.getBrands()
		localStorage.setItem('productFilter', '')
	}

	updateUrlParams() {
		if (this.filterCount > 0) {
			this.router.navigate(['/layout/store/products'], {
				queryParams: { filterCount: this.filterCount },
				queryParamsHandling: 'merge', // Merge with existing query params
			})
		} else {
			this.router.navigate(['/layout/store/products'], {
				queryParams: { filterCount: null },
				queryParamsHandling: 'merge', // Merge with existing query params
			})
		}
	}

	saveFilterState() {
		let filterSave = {
			...this.filterData,
			filterCount: this.filterCount,
		}

		localStorage.setItem('productFilter', JSON.stringify(filterSave))
	}

	ngOnDestroy() {
		this.saveFilterState()
		this.subscription.unsubscribe()
	}
}
